import { render, staticRenderFns } from "./RsaPazienteScaleValutazionePage.vue?vue&type=template&id=825d16d2"
import script from "./RsaPazienteScaleValutazionePage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteScaleValutazionePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports